<template>
  <v-app style="background-color:white;padding-top:130px">
     <go-top></go-top>
     <div style="padding-top:10px;background-color:#F8F8F8">
         <p style="text-align:center;padding-top:25px">
            <span @click="home()" class="hvr1 txt">Home</span> / <span style="color:#7FB4FD" class="txt">{{itemList.categoryName}}</span></p>
     </div>
     <div class="res">
       <v-layout row wrap>
         <v-flex xs2 sm2 md2 style="background-color:#F8F8F8">
           <v-treeview style="padding-left:15px;cursor:pointer;" return-object item-key="id" hoverable activatable selected-color="red"
              @update:active="updateForm" color="warning" :items="items">
           </v-treeview>
      <template slot-scope="{ item }">
                <a @click="updateForm(item)">{{ item.name }}</a>
      </template>
         </v-flex>
         <v-flex xs10 sm10 md10>
           
                <v-layout row wrap style="padding:20px" v-if="itemList.subCategory.length > 0">
                    <v-flex xs12 sm12 md3 v-for="item in itemList.subCategory" :key="item.id" style="padding:10px">
                        <v-card style="border-radius:0px;padding:0px;" flat color="transparent" class="hvr" @click="detail(item)">
              <img :src=item.src width="100%" height="200px"/>
               <h6 style="text-align:center;padding-top:15px;">{{item.categoryName}}</h6>
            </v-card>
                    </v-flex>
                </v-layout>


                <v-layout row wrap style="padding:20px" v-if="itemList.items.length > 0">
                    <v-flex xs12 sm12 md3 v-for="item in itemList.items" :key="item.id" style="text-align:center;padding:10px">
                       <!-- <v-card flat :style="{backgroundImage: `url(${item.src})`}" class="prdt1">
                        <div class="container" style="text-align:left">
                          <p style="text-align:left" class="covid">{{item.categoryName}}</p>
                          <h5 style="text-align:left">{{item.itemName}}</h5>
                          <h4 style="text-align:left;color:#4E97FD">₹&nbsp;{{item.price.toFixed(2)}} <span style="font-size:14px;color:#212121;text-decoration: line-through;">₹&nbsp;{{item.mrp.toFixed(2)}}</span></h4>
                          <p v-if="item.qty > 0" style="text-align:left" class="covid">Available Qty :&nbsp;{{item.qty}}</p>
                          <p v-if="item.qty <= 0" style="text-align:left;color:red" class="covid">Out of Stock</p>
                          <v-btn class="ordr" @click="productDetail(item)" depressed color="#FF6347" dark style="border-radius:20px">Order Now</v-btn>
                        </div>
                       </v-card> -->
                       <v-card style="padding:0px;" class="myimg myDIV">
                          <img class="center " @click="productDetail(item)" :src=item.src style="height:210px;width:210px;" />
                          <p class="txt" style="font-size:13px;">{{item.categoryName}}</p>
                          <p class="txt" style="font-size:13px;font-weight:bold;margin-top:-5px;">{{item.itemName}}</p>
                          <v-btn v-if="item.qty>0" style="border-radius:50px;" depressed dark color="#3381e8" @click="cart(item)">Order Now</v-btn>
                          <div>
                            <v-tooltip top color="#FF3501">
                            <template v-slot:activator="{ on }">
                             <v-btn class="mx-2" v-if="item.qty>0" outline fab dark small color="#FF3501" v-on="on" @click="cart(item)">
                               <v-icon dark>add_shopping_cart</v-icon>
                             </v-btn>
                            </template>
                            <span>Add To Cart</span>
                          </v-tooltip>
                          
                          <v-tooltip top color="pink">
                            <template v-slot:activator="{ on }">
                             <v-btn class="mx-2" outline fab dark small color="pink" v-on="on" @click="wish(item)">
                               <v-icon dark>favorite</v-icon>
                             </v-btn>
                            </template>
                            <span>Add To Wishlist</span>
                          </v-tooltip>

                          <v-tooltip top color="primary">
                            <template v-slot:activator="{ on }">
                             <v-btn class="mx-2" outline fab dark small color="primary" v-on="on" @click="productDetail(item)">
                               <v-icon dark>menu</v-icon>
                             </v-btn>
                            </template>
                            <span>View Details</span>
                          </v-tooltip>
                          </div>
                          
                       </v-card>
                    </v-flex>
                </v-layout>
                <v-container>
                
            </v-container>
         </v-flex>
       </v-layout>
     </div>

     <div style="padding-top:115px" class="man">
       <v-layout row wrap>
         <v-flex xs12 sm12 md12>
                <v-layout row wrap style="padding:20px" v-if="itemList.subCategory.length > 0">
                    <v-flex xs12 sm12 md3 v-for="item in itemList.subCategory" :key="item.id" style="padding:10px">
                        <v-card style="border-radius:0px;padding:0px;" flat color="transparent" class="hvr" @click="detail(item)">
              <img class="myimg" :src=item.src width="100%" height="200px"/>
               <h6 style="text-align:center;padding-top:15px;">{{item.categoryName}}</h6>
            </v-card>
                    </v-flex>
                </v-layout>


                <v-layout row wrap style="padding:20px" v-if="itemList.items.length > 0">
                    <v-flex xs12 sm12 md3 v-for="item in itemList.items" :key="item.id" style="margin:10px">
                        <v-card flat style="padding:15px;" class="myimg myDIV">
                          <img class="center " :src=item.src style="height:200px;width:200px;" />
                          <p class="txt" style="font-size:13px;">{{item.categoryName}}</p>
                          <p class="txt" style="font-size:13px;font-weight:bold;margin-top:-5px;">{{item.itemName}}</p>
                          
                          <v-tooltip top color="#FF3501">
                            <template v-slot:activator="{ on }">
                             <v-btn class="mx-2" v-if="item.qty>0" outline fab dark small color="#FF3501" v-on="on" @click="cart(item)">
                               <v-icon dark>add_shopping_cart</v-icon>
                             </v-btn>
                            </template>
                            <span>Add To Cart</span>
                          </v-tooltip>
                          
                          <v-tooltip top color="pink">
                            <template v-slot:activator="{ on }">
                             <v-btn class="mx-2" outline fab dark small color="pink" v-on="on" @click="wish(item)">
                               <v-icon dark>favorite</v-icon>
                             </v-btn>
                            </template>
                            <span>Add To Wishlist</span>
                          </v-tooltip>

                          <v-tooltip top color="primary">
                            <template v-slot:activator="{ on }">
                             <v-btn class="mx-2" outline fab dark small color="primary" v-on="on" @click="productDetail(item)">
                               <v-icon dark>menu</v-icon>
                             </v-btn>
                            </template>
                            <span>View Details</span>
                          </v-tooltip>
                       </v-card>
                    </v-flex>
                </v-layout>
                <v-container>
                  
                </v-container>
         </v-flex>
         <v-flex xs12 sm12 md3 style="background-color:#F8F8F8">
           <v-treeview style="padding-left:15px;cursor:pointer;" return-object item-key="id" hoverable activatable selected-color="red"
              @update:active="updateForm" color="warning" :items="items">
           </v-treeview>
      <template slot-scope="{ item }">
                <a @click="updateForm(item)">{{ item.name }}</a>
      </template>
         </v-flex>
       </v-layout>
     </div>

  </v-app>
</template>

<script>
import config from "./../../config.json";
/* import carousel from 'vue-owl-carousel'; */
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    GoTop,
    //carousel,
  },
  data() {
    return {
      valid: true,
      form: {
        tourPackage: null,
        destination: null
      },

      id: sessionStorage.id,
      itemList: null,

      items: [],

      selectionType: null,
      selection: [],
    };
    
  },
  
   mounted() {
     this.getData();

     this.axios
        .get(config.API + "CategoryTree", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.items = res.data;
          this.$Progress.finish();
        });
   },

 methods: {
   home(){
      this.$router.push(`/csquad`);
    },
   productDetail(item) {
     this.$router.push(`/productDetail/` + item.itemId);
   },
   cart(item) {
     this.$store.commit('addToCart', item);
   },
   wish(item) {
     this.$store.commit('addToWish', item);
   },
     getData() {
         this.axios
        .get(config.API + "Home/" + this.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemList = res.data;
        });
     },

     updateForm(item)
        {
            if(item.length>0)

                this.axios
        .get(config.API + "Home/" + item[0].id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemList = res.data;
          this.$Progress.finish();
        });
        },

   detail(item) {
       this.axios
        .get(config.API + "Home/" + item.id, {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemList = res.data;
          this.$Progress.finish();
        });
   },

   /* cart(item) {
     this.$store.commit('addToCart', item);
     item.available = item.available - 1;
   } */
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@200&display=swap');
</style>

<style scoped>
.txt {
  font-family: 'Montserrat', sans-serif !important;
}
.banner {
  background-image: url('https://cdnimg.webstaurantstore.com/uploads/seo_category/2018/10/commercial-refrigeration_1.jpg');
  background-size: cover;
  height:200px;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 2px solid;
  border-color: black !important;
}
.hvr1:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #2196f3;
}
.ordr:hover {
  background-color: #166be0 !important;
}
.prdt1 {
  background-size: cover;
  height: auto;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 3px solid;
  border-color: white;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
.myimg {
  transition: height 0.5s ease-out 100ms;
}

.myimg:hover {
  cursor: pointer;
}
.hide {
  display: none;
}

.myDIV:hover + .hide {
  display: inline-block !important;
}
</style>
